import { DarkFlairColors, FlairColor, FlairColors } from '.';

export const getFlairColor = (color: FlairColor, isInverted: boolean) =>
  isInverted ? DarkFlairColors[color] : FlairColors[color];
